import { PoserClock } from "./clock";

const spinnerSize = 64;

export const BUFFERING_CLASS = "fv-buffering";

export class LoadingSpinner {
  constructor() {
    this.injectSpinnerStyles();
  }

  update(clock: PoserClock, container?: HTMLElement) {
    if (!container) {
      return;
    }
    if (clock.atBufferLimit()) {
      container.classList.add(BUFFERING_CLASS);
    } else {
      container.classList.remove(BUFFERING_CLASS);
    }
  }

  private injectSpinnerStyles() {
    // Create our stylesheet
    const style = document.createElement("style");
    style.innerHTML =
      "." +
      BUFFERING_CLASS +
      ":after {" +
      'content: " ";' +
      "position: absolute;" +
      "pointer-events: none;" +
      "top: calc(50% - " +
      spinnerSize / 2 +
      "px);" +
      "left: calc(50% - " +
      spinnerSize / 2 +
      "px);" +
      "display: block;" +
      "width: " +
      spinnerSize +
      "px;" +
      "height: " +
      spinnerSize +
      "px;" +
      "margin: 8px;" +
      "border-radius: 50%;" +
      "border: 6px solid #fff;" +
      "border-color: #fff transparent #fff transparent;" +
      "animation: " +
      BUFFERING_CLASS +
      " 1.2s linear infinite;" +
      "}" +
      "@keyframes " +
      BUFFERING_CLASS +
      " {" +
      "0% {" +
      "transform: rotate(0deg);" +
      "}" +
      "100% {" +
      "transform: rotate(360deg);" +
      "}" +
      "}";

    // Get the first style tag
    const styleRef = document.querySelector("style");

    // Insert our new styles before the first style tag
    styleRef?.parentNode?.insertBefore(style, styleRef);
  }
}
